import { NotFoundContent } from "~/features/not-found/not-found-content.tsx";

import * as styles from "./not-found-page.module.css";

export function NotFoundPage() {
	return (
		<div className={styles.container}>
			<NotFoundContent />
		</div>
	);
}
